import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-friends',
    templateUrl: './friends.component.html',
    styleUrls: ['./friends.component.scss']
})
export class FriendsComponent implements OnInit {

    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Barátaink'});
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/friends/friends.component.ts